const weSideCartEvents = {
    dispatch: { cartUpdated: 'we-cart-changed' },
    listen: { cartUpdate: 'we-cart-update', cartOpen: 'we-cart-open', cartClose: 'we-cart-close' },
}

const weTriggerEvents = {
    cartUpdate: (open=true) => {
        const customEvent = new CustomEvent(weSideCartEvents.listen.cartUpdate, { detail: { open: open } });
        document.dispatchEvent(customEvent);
    },
    cartOpen: () => document.dispatchEvent(new CustomEvent(weSideCartEvents.listen.cartOpen)),
    cartClose: () => document.dispatchEvent(new CustomEvent(weSideCartEvents.listen.cartClose))
}

const SECTION_ID = 'we-cart-drawer';

function randomGpoId() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

function ensureCustomGpoId(scope) {
    scope = scope || document;
    const els = scope.querySelectorAll ? scope.querySelectorAll('[data-option-set-id]') : [];
    for (let i = 0; i < els.length; i++) {
        const el = els[i];
        if (!el.getAttribute('data-custom-gpo-id')) {
            el.setAttribute('data-custom-gpo-id', randomGpoId());
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const state = { isOpen: false, cartDrawer: null };

    function main() {
        ensureCustomGpoId(document);
        state.cartDrawer = document.querySelector(".we-custom-cart-drawer");
        
        // Use Liquid Variable for Initial State if available
        if (typeof window.weInitialCartCount !== 'undefined') {
            updateCartToggleIndicator(window.weInitialCartCount);
        } else {
            updateCartToggleIndicator(); 
        }

        interceptCartPageRemove();

        if(!state.cartDrawer) {
            console.warn("Cart drawer element not found");
            return;
        }

        setupEventListeners();
        interceptProductFormSubmit();
        interceptCartToggleClick();
        updateShippingPrice();
    }

    function interceptCartPageRemove() {
        document.addEventListener("click", function(event) {
            const link = event.target.closest("[data-item-remove]");
            if (!link) return;
            const key = link.getAttribute("data-id");
            if (!key) return;
            event.preventDefault();
            event.stopPropagation();
            removeItemAndCascade(key).then(function() {
                var path = window.location.pathname.replace(/\/$/, "");
                if (path === "/cart") {
                    window.location.reload();
                } else {
                    weTriggerEvents.cartUpdate(false);
                }
            });
        }, true);
    }

    function setupEventListeners(){
        state.cartDrawer.addEventListener('click', function(event) {
            // 1. CLOSE / OVERLAY
            if (event.target.closest('.we-drawer__close-button') || event.target.closest('[data-action="close"]') || event.target.classList.contains("we-drawer-overlay")) {
                event.preventDefault();
                state.isOpen = false;
                close();
                return;
            }

            // 2. QUANTITY SELECTORS
            const plusButton = event.target.closest('.we-quantity-selector__button--plus');
            const minusButton = event.target.closest('.we-quantity-selector__button--minus');
            const removeButton = event.target.closest('.we-remove-item');

            if (!plusButton && !minusButton && !removeButton) return;
            
            const lineItemElement = event.target.closest('.we-drawer__line-item');
            if(!lineItemElement) return;
            
            const key = lineItemElement.getAttribute('we-line-key');
            const quantityElement = lineItemElement.querySelector('[we-quantity]');
            const currentQuantity = parseInt(quantityElement ? quantityElement.getAttribute('we-quantity') : 0);

            if (plusButton) {
                if(!plusButton.hasAttribute('disabled')) updateCartItem(key, currentQuantity + 1);
            } else if (minusButton) {
                updateCartItem(key, currentQuantity - 1);
            } else if (removeButton) {
                removeItemAndCascade(key);
            }
        });

        document.addEventListener(weSideCartEvents.listen.cartUpdate, async (event) => {
            await onRefresh();
            if(event.detail.open) open();
        });
        document.addEventListener(weSideCartEvents.listen.cartOpen, open);
        document.addEventListener(weSideCartEvents.listen.cartClose, close);
    }

    function open(){
        state.isOpen = true;
        if(state.cartDrawer) state.cartDrawer.setAttribute("open", "");
    }

    function close(){
        state.isOpen = false;
        if(state.cartDrawer) state.cartDrawer.removeAttribute("open");
    }

    // --- API ACTIONS ---

    async function getCart() {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        return res.json();
    }

    function getPropertyNames(item) {
        const props = item.properties;
        if (!props || (typeof props === 'object' && Object.keys(props).length === 0)) return [];
        if (Array.isArray(props)) return props.map(function(p) { return String(p.name || p[0] || '').trim(); }).filter(Boolean);
        return Object.keys(props).map(function(k) { return String(k).trim(); }).filter(Boolean);
    }

    function getPropertyNamesFromDOM(key) {
        const keyStr = String(key).trim();
        const link = Array.prototype.find.call(document.querySelectorAll('[data-item-remove]'), function(el) { return el.getAttribute('data-id') === keyStr; });
        const row = link ? link.closest('[data-cart-item], .cart__item, [data-item]') : Array.prototype.find.call(document.querySelectorAll('[data-item]'), function(el) { return el.getAttribute('data-item') === keyStr; });
        if (!row) return [];
        const propEls = row.querySelectorAll('.cart__item__property');
        const names = [];
        propEls.forEach(function(el) {
            const firstSpan = el.querySelector('span');
            if (firstSpan) {
                const text = (firstSpan.textContent || '').trim().replace(/\s*:\s*$/, '');
                if (text) names.push(text);
            }
        });
        return names;
    }

    async function removeItemAndCascade(key) {
        const keyStr = String(key).trim();
        const cart = await getCart();
        const item = cart.items.find(function(i) { return (i.key && String(i.key).trim() === keyStr) || i.key === key; });
        if (!item) return;

        const customGpoId = item.properties && item.properties._custom_gpo_id;

        if (customGpoId) {
            // Remove all items with matching _custom_gpo_id (same option set)
            const keysToRemove = cart.items
                .filter(function(i) { return i.properties && i.properties._custom_gpo_id === customGpoId; })
                .map(function(i) { return i.key; });
            for (let i = 0; i < keysToRemove.length; i++) {
                await updateCartItem(keysToRemove[i], 0);
            }
            return;
        }

        let propNames = getPropertyNames(item);
        if (propNames.length === 0) propNames = getPropertyNamesFromDOM(keyStr);

        await updateCartItem(keyStr, 0);

        if (propNames.length === 0) return;

        const cartAfter = await getCart();
        function normalizeTitle(t) {
            return (t || '').toString().trim();
        }
        for (let p = 0; p < propNames.length; p++) {
            const connectedTitle = normalizeTitle(propNames[p]);
            if (!connectedTitle) continue;
            const connectedLine = cartAfter.items.find(function(i) {
                const title = normalizeTitle(i.product_title || i.title || '');
                return title === connectedTitle;
            });
            if (connectedLine && connectedLine.quantity > 0) {
                await updateCartItem(connectedLine.key, connectedLine.quantity - 1);
            }
        }
    }

    async function updateCartItem(key, quantity){
        try {
            const sectionId = (state.cartDrawer && state.cartDrawer.getAttribute('data-section-id')) || SECTION_ID;
            const body = {
                id: key,
                quantity: quantity,
                sections: [sectionId]
            };
            const currentPath = (window.location.pathname || '').replace(/\/$/, '');
            if (currentPath === '/cart') {
                body.sections_url = '/cart';
            }
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });

            if(!response.ok) {
                const errorData = await response.json();
                alert(errorData.description || "Cannot update cart");
                return;
            }

            const data = await response.json();
            const sectionHtml = data.sections && data.sections[sectionId];
            if (sectionHtml) {
                renderSection(sectionHtml);
            } else if (state.cartDrawer) {
                await onRefresh();
            }
            updateCartToggleIndicator(data.item_count);

        } catch(error) {
            console.error('[we-cart] Error updating item:', error);
        }
    }

    async function onRefresh(){
        try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=${SECTION_ID}`);
            const data = await response.json();
            renderSection(data[SECTION_ID]);
            
            const cartRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
            const cart = await cartRes.json();
            updateCartToggleIndicator(cart.item_count);
        } catch(error) {
            console.error('[we-cart] Error refreshing:', error);
        }
    }

    function renderSection(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('.we-custom-cart-drawer');
        if (state.cartDrawer && newContent) {
            state.cartDrawer.innerHTML = newContent.innerHTML;
            updateShippingPrice();
        }
    }

    function updateShippingPrice() {
        if (!state.cartDrawer) return;

        const shippingRowElement = state.cartDrawer.querySelector('.we-drawer__footer-row--shipping');
        if (!shippingRowElement) return;

        const footerPriceElement = shippingRowElement.querySelector('.we-drawer__footer-price');
        if (!footerPriceElement) return;

        const remainingAttr = state.cartDrawer.querySelector('[data-free-shipping-remaining]');
        let remaining = remainingAttr ? parseInt(remainingAttr.getAttribute('data-free-shipping-remaining'), 10) : NaN;

        if (Number.isNaN(remaining)) {
            const progressPriceElement = state.cartDrawer.querySelector('.we-drawer__progress-text-current-price');
            if (!progressPriceElement) return;
            const priceMatch = progressPriceElement.textContent.trim().match(/[\d,]+/);
            if (!priceMatch) return;
            remaining = Math.round(parseFloat(priceMatch[0].replace(',', '.')) * 100);
        }

        if (remaining === 0) {
            footerPriceElement.textContent = 'GRATIS';
            footerPriceElement.classList.add('we-drawer__footer-price--gratis');
        } else {
            footerPriceElement.textContent = '4,90 €';
            footerPriceElement.classList.remove('we-drawer__footer-price--gratis');
        }
    }

    function updateCartToggleIndicator(count){
        if(typeof count === 'undefined'){
            const counter = document.querySelector('.product-count');
            count = counter ? parseInt(counter.innerText) : 0;
        }

        const cartToggleLinks = document.querySelectorAll(".cart__toggle");
        cartToggleLinks.forEach(link => {
            if(count > 0){
                link.classList.add("cart__toggle--has-items");
            } else {
                link.classList.remove("cart__toggle--has-items");
            }
        });
    }

    // --- HYBRID ADD TO CART ---

    function parseJsonResponse(response) {
        return response.text().then(function(text) {
            if (text.trim().startsWith('<')) {
                throw new Error('Cart request failed: server returned an error page (status ' + response.status + ').');
            }
            try {
                return JSON.parse(text);
            } catch (e) {
                throw new Error('Cart request failed: invalid response from server.');
            }
        });
    }

    function interceptProductFormSubmit(){
        // Use event delegation with capture phase to intercept before theme.dev.js handler
        // Listen for clicks on buttons with data-add-to-cart or class product__submit__add
        // Using capture: true ensures this runs before theme.dev.js handler
        document.addEventListener("click", async function(event){
            const clickedElement = event.target;
            
            // Check if clicked element or its closest parent is the add to cart button
            const button = clickedElement.matches('.product__submit__add, [data-add-to-cart]') 
                ? clickedElement 
                : clickedElement.closest('.product__submit__add, [data-add-to-cart]');
            
            if(!button) return;
            
            // Find the form containing this button
            const form = button.closest('form[action*="/cart/add"]');
            if(!form) return;

            // --- NEW CHECK: If button is disabled via class, ignore action ---
            if(button.classList.contains("we-cart-add-to-cart-disabled")){
                event.preventDefault();
                event.stopImmediatePropagation();
                return;
            }
            // ----------------------------------------------------------------

            // Prevent default and stop propagation to prevent theme.dev.js from handling it
            event.preventDefault();
            event.stopImmediatePropagation();
            
            clearErrors(form);
            button.setAttribute('disabled', 'disabled');
            button.classList.add('is-loading');

            try {
                const formData = new FormData(form);
                const variantId = Number(formData.get('id'));
                const qtyToAdd = Number(formData.get('quantity') || 1);

                // Collect GPO variant IDs from inputs with gpo-data-variant-id that are filled
                // ID is in the attribute (e.g. gpo-data-variant-id="45856834650334")
                // Only text inputs: filled = value not empty (checkboxes/radio ignored for now)
                const gpoInputs = document.querySelectorAll('input[gpo-data-variant-id]');
                const gpoVariantIds = [];
                gpoInputs.forEach(function(input) {
                    if (input.type === 'hidden') return;
                    const idAttr = input.getAttribute('gpo-data-variant-id');
                    if (!idAttr) return;
                    const id = Number(idAttr);
                    if (Number.isNaN(id)) return;
                    const isCheckboxOrRadio = input.type === 'checkbox' || input.type === 'radio';
                    const isFilled = isCheckboxOrRadio ? input.checked : (input.value || '').trim() !== '';
                    if (isFilled) gpoVariantIds.push(id);
                });
                const uniqueGpoVariantIds = [...new Set(gpoVariantIds)];

                // Ensure data-custom-gpo-id is assigned (scans full document for dynamic popups), then get value
                ensureCustomGpoId(document);
                const optionSetEl = form.closest('[data-option-set-id]') || document.querySelector('[data-option-set-id]');
                const customGpoId = optionSetEl ? optionSetEl.getAttribute('data-custom-gpo-id') : null;

                // Check Cart State
                const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
                const cartData = await parseJsonResponse(cartResponse);
                const existingItem = customGpoId
                    ? cartData.items.find(item => item.variant_id === variantId && item.properties && item.properties._custom_gpo_id === customGpoId)
                    : cartData.items.find(item => item.variant_id === variantId && (!item.properties || !item.properties._custom_gpo_id));
                
                let response;

                if(existingItem) {
                    // Change (Strict)
                    const newQuantity = existingItem.quantity + qtyToAdd;
                    response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            id: existingItem.key,
                            quantity: newQuantity,
                            sections: [SECTION_ID]
                        })
                    });
                } else {
                    // Add
                    formData.append('sections', SECTION_ID);
                    formData.append('sections_url', window.location.pathname);
                    if (customGpoId) {
                        formData.append('properties[_custom_gpo_id]', customGpoId);
                    }
                    response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
                        method: 'POST',
                        body: formData
                    });
                }

                const data = await parseJsonResponse(response);

                if(!response.ok){
                    if(data.status === 422){
                        showMaximumQuantityError(form, 'main');
                    } else {
                        alert(data.description);
                    }
                    throw new Error(data.description);
                }

                let lastSectionHtml = data.sections[SECTION_ID];

                // Add each GPO variant from filled gpo-data-variant-id inputs
                for (let i = 0; i < uniqueGpoVariantIds.length; i++) {
                    const gpoVariantId = uniqueGpoVariantIds[i];
                    const gpoCartRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
                    const gpoCartData = await parseJsonResponse(gpoCartRes);
                    const gpoExistingItem = customGpoId
                        ? gpoCartData.items.find(item => item.variant_id === gpoVariantId && item.properties && item.properties._custom_gpo_id === customGpoId)
                        : gpoCartData.items.find(item => item.variant_id === gpoVariantId && (!item.properties || !item.properties._custom_gpo_id));
                    let gpoResponse;
                    if (gpoExistingItem) {
                        gpoResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: gpoExistingItem.key,
                                quantity: gpoExistingItem.quantity + 1,
                                sections: [SECTION_ID]
                            })
                        });
                    } else {
                        const gpoFormData = new FormData();
                        gpoFormData.append('id', gpoVariantId);
                        gpoFormData.append('quantity', 1);
                        gpoFormData.append('sections', SECTION_ID);
                        gpoFormData.append('sections_url', window.location.pathname);
                        if (customGpoId) {
                            gpoFormData.append('properties[_custom_gpo_id]', customGpoId);
                        }
                        gpoResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
                            method: 'POST',
                            body: gpoFormData
                        });
                    }
                    const gpoData = await parseJsonResponse(gpoResponse);
                    if (!gpoResponse.ok) {
                        if (gpoData.status === 422) {
                            showMaximumQuantityError(form, 'gpo');
                        } else {
                            alert(gpoData.description || 'Could not add item');
                        }
                        throw new Error(gpoData.description || 'GPO add failed');
                    }
                    if (gpoData.sections && gpoData.sections[SECTION_ID]) {
                        lastSectionHtml = gpoData.sections[SECTION_ID];
                    }
                }

                renderSection(lastSectionHtml);
                
                const finalCartRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
                const finalCart = await parseJsonResponse(finalCartRes);
                updateCartToggleIndicator(finalCart.item_count);

                // Assign new custom GPO ID so next add creates a fresh set
                if (optionSetEl) {
                    optionSetEl.setAttribute('data-custom-gpo-id', randomGpoId());
                }
                
                // Close popup quick view if it's open
                // Find the popup container that contains the form, then find the close button within it
                const popupContainer = form.closest('.popup-quick-view, .pswp');
                if(popupContainer) {
                    const popupCloseButton = popupContainer.querySelector('.popup-quick-view__close, [data-popup-close]');
                    if(popupCloseButton) {
                        popupCloseButton.click();
                    }
                } else {
                    // Fallback: try to find any popup close button
                    const popupCloseButton = document.querySelector('.popup-quick-view__close, [data-popup-close]');
                    if(popupCloseButton) {
                        popupCloseButton.click();
                    }
                }

                // Open side cart after popup close (defer so popup close handlers don't close the drawer)
                setTimeout(function() { open(); }, 0);

            } catch(error) {
                // Add to cart failed – error already surfaced via alert or showMaximumQuantityError
            } finally {
                button.removeAttribute('disabled');
                button.classList.remove('is-loading');
            }
        }, { capture: true }); // Use capture phase to run before theme.dev.js handler
    }

    function interceptCartToggleClick(){
        document.addEventListener("click", function(event){
            const cartToggleLink = event.target.closest(".cart__toggle");
            if(!cartToggleLink) return;

            const currentPath = window.location.pathname;
            if(currentPath === '/cart' || currentPath === '/cart/') return;

            event.preventDefault();
            open();
        });
    }

    function showMaximumQuantityError(form, source) {
        const errorContainer = form.querySelector('.product__form_errors') || document.querySelector('.product__form_errors') || document.querySelector('.product__form__errors');
        if (!errorContainer) return;

        const errorHTML = `
            <div class="errors" data-error="" autofocus="">
                Die maximale Menge dieses Artikels befindet sich bereits in deinem Warenkorb.
                <button type="button" class="errors__button-close" data-close-error="">
                    <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                </button>
            </div>
        `;
        errorContainer.innerHTML = errorHTML;
        errorContainer.classList.add('is-visible');
        
        const closeBtn = errorContainer.querySelector('[data-close-error]');
        if(closeBtn) {
            closeBtn.addEventListener('click', () => {
                errorContainer.classList.remove('is-visible');
                errorContainer.innerHTML = '';
            });
        }
    }

    function clearErrors(form) {
        const errorContainer = form.querySelector('.product__form_errors') || document.querySelector('.product__form_errors') || document.querySelector('.product__form__errors');
        if (errorContainer) {
            errorContainer.classList.remove('is-visible');
            errorContainer.innerHTML = '';
        }
    }

    main(); 
});